module.exports = __webpack_public_path__ + "static/media/edit-field.d45ef6e5.svg";